<template>
<div :class="primitiveBaseClasses">
    <div :class="{ 'invalid': validationMessage, 'amfMultiselect': true }">
        <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>
        <multiselect
            style="line-height: 1;"
            v-model="selectedObj"
            v-bind="attrs"
            :placeholder="caption"
            :title="label"
            :options="selectOptions"
            :multiple="true"
            :hideSelected="true"
            :disabled="disabled">
        </multiselect>
        <div class="error-div">
            {{validationMessage}}
        </div>
    </div>
</div>
</template>

<script>
import primitiveMixin from './primitive-mixin'
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    mixins:[primitiveMixin],
    props: {
        value: [Array],
        mapId: { type: String, default: null },
        mapName: { type: String, default: null },
        enumName: String,
        label: String,
        options: { type: Array, required: true },
        caption: { type: String, default: null },
        returnObject: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        attrs() {
          return {
            trackBy: !this.isSimpleValue() ? 'name' : null,
            label: !this.isSimpleValue() ? 'name' : null
          }
        },
        selectOptions() {
            if(this.enumName) {
                let options = this.lookup(this.enumName).all();
                let enumOptions = mapToSelect(options, 'name', 'description');
                return this.enumOptions;
            }
            else {
                if(this.mapId) {
                    return mapToSelect(this.options, this.mapId, this.mapName);
                }
                else if(this.mapName) {
                    return mapToSelect(this.options, 'id', this.mapName);
                }
                else {
                    return this.options;
                }
            }
        }
    },
    methods: {
      isSimpleValue() {
        const checkItem = this.options[0];
        return checkItem &&  (typeof checkItem === 'string' || checkItem instanceof String);
      }
    },
    data() {
        return {
            selectedObj: this.value
        }
    },
    watch: {
        selectedObj(newValue, oldValue) {
            if (JSON.stringify(oldValue) == JSON.stringify(newValue)) return;
            this.changeMade({ name: this.label, value: newValue });
            this.$emit('input', newValue);
        },
        value(newValue) {
            this.selectedObj = newValue;
        },
        selectOptions(newValue, oldValue) {
            if(this.enumName && (!oldValue || oldValue.length == 0) && (newValue && newValue.length > 0)){
                this.selectedObj = this.value;
            }
        }
    }
}

function mapToSelect(values, mapId, mapName = null) {
    return values.map(option => {
        let value = { ...option };
        let displayText = '';
        if(mapName) {
            displayText = value[mapName];
        }
        else if(value.name) {
            displayText = value.name;
        }
        else if(value.description) {
            displayText = value.description;
        }
        value.id = value[mapId];
        value.name = displayText;
        return value;
    });
};
</script>

<style scoped>
.invalid .multiselect {
    margin: -2px;
    border: solid 2px #f00;
    border-radius: .30rem;
}

.amfMultiselect >>> .multiselect__tag,
.amfMultiselect >>> .multiselect__option--highlight,
.amfMultiselect >>> .multiselect__option--highlight:after,
.amfMultiselect >>> .multiselect__tag-icon:hover {
    color: black;
    background-color: #eee;
}

.amfMultiselect >>> .multiselect__tag-icon:hover:after { 
    color: black;
}
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfMultipleSelect.vue